import { cn } from '../../lib/utils';

function Box({ children, className, ...props }: React.ComponentProps<'div'>) {
  return (
    <div
      className={cn('bg-neutral rounded-xl p-6 shadow-sm', className)}
      {...props}
    >
      {children}
    </div>
  );
}

export { Box };
